import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="nav-item">
  <div class="nav-link-indicator">
    <slot></slot>
  </div>
</div>
`

class NavHeaderPrimaryLink extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {}
}

if (!customElements.get('ts-navheader-primary-link')) {
  customElements.define('ts-navheader-primary-link', NavHeaderPrimaryLink)
}

export { NavHeaderPrimaryLink }
